var exports = {
  "f": "ListItemTitle_0__PYp9aW",
  "m": "ListItemTitle_1__iy5932",
};

module.exports = exports;
